import { render, staticRenderFns } from "./Parsec.vue?vue&type=template&id=4b3099e2&"
import script from "@/scripts/parsec/parsec.js?vue&type=script&lang=js&"
export * from "@/scripts/parsec/parsec.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports